module.exports = function (app) {
    app.controller("pages.faqs", ["$scope", "$state", "aemContent", function($scope, $state, aemContent){
        $scope.headings = "FAQs";
        $scope.topics = [];

        $scope.sidebar.links = [
            {
                heading: "You have Questions, We have Answers.",
                label: "FAQs",
                state: "faqs",
                description : "We address most common questions about health care benefits. Here are some general FAQs that provide easy-to-understand explanations of what you need to know about your health care benefits and options."
            }
        ]

        aemContent.get("MBR_FAQS").then(function(response){

            var jsonResponse = JSON.parse(response);
            $scope.faqs = jsonResponse;
            angular.forEach(jsonResponse, function(item){
                if($scope.topics.indexOf(item.tags) === -1){
                    $scope.topics.push(item.tags);
                    var link = {
                        heading:"",
                        label: item.tags,
                        href:"/login/#/faqs#" + item.tags,
                        description:""
                    }
                    $scope.sidebar.links.push(link);
                }
            });

        });

    }]);

    return [
        {
            state: "faqs",
            postPassword:true,
            url: "/faqs",
            views: {
                "body@": {
                    template: bootstrap.templates["page-templates/categoryCustom.html"],
                    controller: "pages.faqs"
                },
                "content@faqs":{
                    templateUrl: 'faqs.appTemplate.html/chmhom/pages/faqs'
                }
            }
        }
    ]

};

